import { useState, useEffect, useRef, memo } from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import axios from "axios";
import ThemeMaker from "../../components/thememaker";
import { tokenDecode } from "../../utils/helper";
import { toast } from "react-toastify";
import { config } from "../../utils/config";

import NewCategorylist from "../../components/CategoryTemplate/NewCategorylist";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
// import styles from "../transaction/transaction.module.css"
import styled from "styled-components"
import style from "../SellerDetails/Sellerdetails.module.css"
import styles from "./Addcategory.module.css"
import brandStyles from "../Brand/Brand.module.css"
import { Link } from "react-router-dom"
import { CATEGORY_MAX_LENGTH, normalizeCategoryName, validateCategoryName } from "../../utils/categoryValidation";
import "../../index.css"
import "../../components/mcrbTableTheme.css"
const { apiEndpoint } = config
var $ = require('jquery');
const CATEGORY_STATUS_KEY = "category-status-draft";

const showCategoryApiError = (error, fallback = "Category request failed.") => {
    toast.error(error?.response?.data?.message || error?.message || fallback);
};

const Wrapper = styled.div
    `
padding: 10px;
display: flex;
flex-wrap: wrap


`
let arr = []
let Ndata = arr;
const Addcategory = () => {
    const decoded = tokenDecode();
    const { data } = decoded;
    const { permission: { category } } = data;
    const [listing, setListing] = useState(false);
    let rawSubCatData = {
        parent_id: "",
        cat_name: "",
        status: true,
        id: ""
    }
    const [Subcategorydata, setSubcategorydata] = useState(rawSubCatData);
    const [isUpdate, setIsUpdate] = useState(false);
    const [taxData, setTaxData] = useState([]);
    const [selectsub, setSelectsub] = useState(0);
    const [tax, setTax] = useState(() => ({
        tax: '',
        status: localStorage.getItem(CATEGORY_STATUS_KEY) !== "false",
        id: ''
    }));

    useEffect(() => {
        localStorage.setItem(CATEGORY_STATUS_KEY, String(tax.status));
    }, [tax.status]);

    const taxD = {
        tax: false,
        name: false,
        parent_id: false
    }
    const [taxErrorData, setTaxErrorData] = useState(taxD);
    const errorHandler = (e) => {
        const normalizedValue = normalizeCategoryName(e.target.value);
        setTax((previousTax) => ({ ...previousTax, [e.target.name]: normalizedValue }));
        setTaxErrorData({ ...taxErrorData, [e.target.name]: validateCategoryName(normalizedValue) });
    }


    const createTaxHandler = async () => {
        try {

            const categoryName = normalizeCategoryName(tax?.tax);
            const validationMessage = validateCategoryName(categoryName);
            setTax((previousTax) => ({ ...previousTax, tax: categoryName }));
            setTaxErrorData({ ...taxErrorData, tax: validationMessage });

            if (!validationMessage) {
                const { data } = await axios({
                    url: `${apiEndpoint}/addcategorie`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        cat_name: categoryName,
                        status: tax.status
                    }
                });

                if (data.status === 200) {
                    toast.success("New Category created !", {
                        position: "top-right",
                        autoClose: 1000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                    taxListHanler()
                    setTax({
                        tax: '',
                        status: true,
                        id: ''
                    })
                    localStorage.removeItem(CATEGORY_STATUS_KEY);
                } else {
                    showCategoryApiError({ response: { data } });
                }
            } else {
                toast.error(validationMessage, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }

        } catch (error) {

            showCategoryApiError(error);
        }
    }

    const taxListHanler = async () => {
        try {
            setListing(true);
            const { data } = await axios({
                url: `${apiEndpoint}/ptgetcategories`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            if (data.status === 200) {
                setTaxData(data.response);
            }
            setListing(false);
        } catch (error) {
            console.log(error)
            toast.error("Something went wrong");

        }
    }

    const editRedirect = async (id, parentCatName, isParentCategory) => {
        let endpointforCategoryView
        if (isParentCategory) {
            endpointforCategoryView = "ptcatsub"
        } else {
            endpointforCategoryView = "ptgetcatsub"
        }
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/${endpointforCategoryView}`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    "id": id
                }
            });
            if (!isParentCategory) {
                if (data.status === 200) {
                    setTax({
                        tax: data?.parent_id?.cat_name,
                        status: data?.parent_id?.status,
                        id: data?.parent_id?.id
                    });
                    setSubcategorydata({
                        parent_id: data?.parent_id?.parent_id,
                        cat_name: data?.parent_id?.cat_name,
                        status: data?.parent_id?.status,
                        id: data?.parent_id?.id
                    })
                    setSelectsub(data?.parent_id?.parent_id)

                }
            }

            if (isParentCategory) {
                if (data.status === 200) {
                    setTax({
                        tax: data?.parent_id[0]?.cat_name,
                        status: data?.parent_id[0]?.status,
                        id: data?.parent_id[0]?.id
                    });
                    setSubcategorydata({
                        parent_id: data?.parent_id[0]?.parent_id,
                        cat_name: data?.parent_id[0]?.cat_name,
                        status: data?.parent_id[0]?.status,
                        id: data?.parent_id[0]?.id
                    })
                    setSelectsub(data?.parent_id[0]?.parent_id)

                }
            }

        } catch (error) {

        }
        setIsUpdate(true);
        setListing(false);
        if (parentCatName !== "") {

        } else {
            ;
        }


    }


    const updateTax = async () => {
        try {
            const categoryName = normalizeCategoryName(tax?.tax);
            const validationMessage = validateCategoryName(categoryName);
            setTax((previousTax) => ({ ...previousTax, tax: categoryName }));
            setTaxErrorData({ ...taxErrorData, tax: validationMessage });

            if (!validationMessage) {

                console.log("tax", tax);
                const { data } = await axios({
                    url: `${apiEndpoint}/updatecategories`,
                    method: "POST",
                    headers: {
                        "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                    },
                    data: {
                        "cat_name": categoryName,
                        "status": tax.status,
                        id: tax.id
                    }
                });
                // console.log("data----", data);
                if (data.status === 200) {
                    toast.success("Category Updated !");
                    taxListHanler()
                    setIsUpdate(false)
                    setTax({
                        tax: '',
                        status: true,
                        id: ''
                    })
                } else {
                    showCategoryApiError({ response: { data } });
                }
            } else {
                toast.error(validationMessage);
            }

        } catch (error) {
            showCategoryApiError(error);
        }
    }


    const deleteTax = async (id, parent_id) => {
        try {


            const { data } = await axios({
                url: `${apiEndpoint}/ptdelcatshiftsubcat`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: { id, product_cat_id: parent_id }
            });
            if (data.status === 200) {
                toast.success("Category Deleted !");
                taxListHanler();
            } else {
                toast.error("403 Error !");
            }
        } catch (error) {
            toast.error("403 Error !");
        }
    }


    useEffect(() => {
        taxListHanler()
    }, [])


    console.log(isUpdate, listing)
    return (
        <>
            <ThemeMaker>
                <div className={`${styles.pageWrap} mcrb-page`}>

                    <div className={styles.toolbarCard}>

                        <div className={styles.field}>
                            <label className={styles.label}>
                                Category name<span className={styles.required}>*</span>
                            </label>
                            {
                                taxErrorData?.tax ? (
                                    <span className={styles.errorText}>{taxErrorData.tax}</span>
                                ) : null
                            }
                            <input type="text" className={styles.input} name="tax" placeholder="Enter Category Name.."
                                value={tax.tax}
                                maxLength={CATEGORY_MAX_LENGTH}
                                onChange={(e) => {
                                    setTax({ ...tax, [e.target.name]: e.target.value });
                                    setTaxErrorData({ ...taxErrorData, tax: validateCategoryName(e.target.value) });
                                }}
                                onBlur={(e) => errorHandler(e)}

                            />
                        </div>

                        <div className={styles.fieldSmall}>
                            <label className={styles.label}>Status</label>
                            <select value={String(Boolean(tax.status))} name="status" className={styles.select} onChange={(e) => setTax({ ...tax, status: e.target.value === "true" })}>
                                <option value="true">Active</option>
                                <option value="false">Inactive</option>
                            </select>
                        </div>

                        <div>
                            {
                                !isUpdate && !listing ? (
                                    <button type="submit" className={styles.saveBtn}
                                        onClick={createTaxHandler}
                                    >
                                        Save
                                    </button>
                                ) : (
                                    <button type="submit" className={styles.updateBtn}
                                        onClick={updateTax}
                                    >
                                        Update
                                    </button>
                                )
                            }
                        </div>

                    </div>

                    <div className={`${brandStyles.cardOuter} mcrb-card`}>
                        <div className={brandStyles.headerBar}>
                            <span className={brandStyles.title}>Category List</span>
                            <Link to="/subcategory">
                                <button className={brandStyles.primaryBtn}>Add Subcategory</button>
                            </Link>
                        </div>

                        <div className={brandStyles.bodyArea}>
                            <NewCategorylist item={taxData} editRedirect={editRedirect} deleteTax={deleteTax} />
                        </div>
                    </div>

                </div>
            </ThemeMaker>

        </>
    )
}

export default Addcategory;
